module.exports = __webpack_public_path__ + "static/jungle-fc4da7742af807dbb02d0a07e2203ad2.mp3";